import React from 'react';
import ImageUploader from './ImageUploader';
import AnswerOptions from './AnswerOptions';
import { getImageUrl } from '../utils/helpers';

function QuestionStep({ 
  step, 
  stepIndex, 
  planId, 
  onQuestionImageUpload, 
  onOptionImageUpload,
  onUpdateStep,
  onUpdateQuestionOption,
  onAddQuestionOption,
  onRemoveQuestionOption,
  onImageClick
}) {
  if (!step.question) return null;

  return (
    <div className="form-group">
      <label>Question Configuration</label>
      <div style={{ marginBottom: '1rem' }}>
        <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.875rem' }}>Question Type</label>
        <select
          className="form-control"
          value={step.question.type}
          onChange={(e) => onUpdateStep(stepIndex, 'question', { ...step.question, type: e.target.value })}
        >
          <option value="single">Single Select</option>
          <option value="multi">Multi Select</option>
          <option value="evaluate">Evaluate Items</option>
        </select>
      </div>
      
      <div style={{ marginBottom: '1rem' }}>
        <label 
          className="pretty-checkbox-label"
          onClick={() => onUpdateStep(stepIndex, 'question', { ...step.question, required: !(step.question.required || false) })}
        >
          <div className={`pretty-checkbox ${step.question.required ? 'checked' : ''}`}></div>
          Required (at least one option must be selected)
        </label>
      </div>
      
      <div>
        <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.875rem' }}>Question Images (optional)</label>
        <ImageUploader
          onImageUpload={(files) => onQuestionImageUpload(stepIndex, files)}
          planId={planId}
          label="📸 Click to upload question images"
          images={step.question.images || []}
          onImageClick={onImageClick}
          style={{ marginBottom: '1rem' }}
        />
      </div>
      
      <AnswerOptions
        step={step}
        stepIndex={stepIndex}
        planId={planId}
        onOptionImageUpload={onOptionImageUpload}
        onUpdateQuestionOption={onUpdateQuestionOption}
        onAddQuestionOption={onAddQuestionOption}
        onRemoveQuestionOption={onRemoveQuestionOption}
        onImageClick={onImageClick}
      />
    </div>
  );
}

export default QuestionStep; 